import { HttpClient } from "@angular/common/http";

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { CachedDataSurveyService } from '../../technical-modules/tasks/services/cached-data-survey.service';

export abstract class ImportService {
	private importRoot: string;

	constructor(
		protected httpClient: HttpClient,
		protected cachedDataSurveyService: CachedDataSurveyService,
		private resourceName: string,
		private typeName: string,
	) {
		this.importRoot = (window as any).baseApiPath;
	}
	
	public import(file: File): Observable<number> {
		let url = this.importRoot + this.resourceName + "/import-file";
	
		let formData = new FormData();
		formData.append("file", file);

		return this.httpClient.post<number>(url, formData).pipe(
			tap(
				() => this.cachedDataSurveyService.notifyImmediateChange(this.typeName)
			)
		);
	}
}